var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfitIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 80,
    viewBox: "0 0 75 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2868_19470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9271 38.498V36.3669C42.3165 35.8069 44.7822 33.5885 44.7822 30.8537V28.4171C44.6658 26.3297 43.2475 24.5477 41.2473 23.9513L34.4976 21.2965C34.1631 21.1655 33.0721 20.6782 33.0721 19.9291V17.4852C33.0721 16.3942 34.8686 15.165 37.2615 15.165C39.6545 15.165 41.451 16.3869 41.451 17.4852V19.1072C41.4728 19.9873 42.1856 20.7 43.0657 20.7219C43.9821 20.751 44.7458 20.0236 44.7749 19.1072V17.4925C44.7749 14.7577 42.3093 12.532 38.9199 11.9793V9.84815C38.9199 9.84815 38.9199 9.78269 38.9199 9.7536C38.8908 8.83715 38.1271 8.10981 37.2106 8.1389C36.2942 8.168 35.5668 8.9317 35.5959 9.84815V11.9793C32.2065 12.5393 29.7408 14.7577 29.7408 17.4925V19.9363C29.8572 22.0238 31.2755 23.8058 33.2757 24.4022L40.0254 27.057C40.36 27.1879 41.451 27.6752 41.451 28.4244V30.861C41.451 31.9593 39.6545 33.1812 37.2615 33.1812C34.8686 33.1812 33.0721 31.9593 33.0721 30.861V29.239C33.0502 28.3589 32.3374 27.6461 31.4574 27.6243C30.5409 27.5952 29.7772 28.3226 29.7481 29.239V30.861C29.7481 33.603 32.2138 35.8214 35.6032 36.3742V38.5126C35.625 39.3927 36.3378 40.1054 37.2179 40.1273C38.1343 40.1564 38.898 39.429 38.9271 38.5126V38.498Z",
    fill: "url(#paint0_linear_2868_19470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7705 67.8534L30.8537 63.424C29.8645 62.5221 28.3807 61.1765 27.457 60.3619C28.7662 56.1287 28.4171 52.4339 26.4096 49.3645C22.9475 44.084 14.6558 41.0292 1.76012 40.2728C0.843674 40.2218 0.0581475 40.9201 -3.95689e-05 41.8365C-0.0145863 42.0256 0.0145072 42.222 0.0654209 42.4039C3.7603 54.7759 8.64075 62.1438 14.5758 64.304C15.7832 64.7477 17.0633 64.9732 18.3507 64.9732C20.8164 64.915 23.2239 64.2022 25.3259 62.9148L30.9773 68.0789C31.5301 68.5881 31.8865 68.9226 31.8865 68.9226V68.9081L35.7632 72.4502V67.8534H35.7705Z",
    fill: "url(#paint1_linear_2868_19470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0581 67.8534L43.9749 63.424C44.9641 62.5221 46.4479 61.1765 47.3716 60.3619C46.0624 56.1287 46.4115 52.4339 48.419 49.3645C51.8811 44.084 60.1728 41.0292 73.0685 40.2728C73.9849 40.2218 74.7704 40.9201 74.8286 41.8365C74.8432 42.0256 74.8141 42.222 74.7632 42.4039C71.0683 54.7759 66.1878 62.1438 60.2528 64.304C59.0454 64.7477 57.7653 64.9732 56.4779 64.9732C54.0122 64.915 51.6047 64.2022 49.5027 62.9148L43.8513 68.0789C43.2985 68.5881 42.9421 68.9226 42.9421 68.9226V68.9081L39.0654 72.4502V67.8534H39.0581Z",
    fill: "url(#paint2_linear_2868_19470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4143 44.6223C48.9832 44.6223 58.3616 35.2438 58.3616 23.6749C58.3616 12.106 48.9832 2.72754 37.4143 2.72754C25.8454 2.72754 16.4669 12.106 16.4669 23.6749C16.4669 35.2438 25.8454 44.6223 37.4143 44.6223Z",
    stroke: "url(#paint3_linear_2868_19470)",
    strokeWidth: 7.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3779 46.9352V77.2725",
    stroke: "url(#paint4_linear_2868_19470)",
    strokeWidth: 7.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2868_19470",
    x1: 37.2615,
    y1: 8.13806,
    x2: 37.2615,
    y2: 40.1281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2868_19470",
    x1: 17.8834,
    y1: 40.2701,
    x2: 17.8834,
    y2: 72.4502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2868_19470",
    x1: 56.9452,
    y1: 40.2701,
    x2: 56.9452,
    y2: 72.4502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2868_19470",
    x1: 37.4143,
    y1: 2.72754,
    x2: 37.4143,
    y2: 44.6223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2868_19470",
    x1: 37.8779,
    y1: 46.9352,
    x2: 37.8779,
    y2: 77.2725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2868_19470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.8286,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitIcon);
export default __webpack_public_path__ + "static/media/ProfitIcon.ae22c54c204232f661e5a57d6eb3cd1f.svg";
export { ForwardRef as ReactComponent };